declare global {
  // eslint-disable-next-line
  interface Window {
    Weblog: any;
  }
}
const buffer: any = {
  collect: [],
  sendImmediately: [],
  updateCommonPackage: [],
  pluginsRadarEvent: [],
};

export function getUrlParams() {
  // 如果未提供url，则使用当前页面的URL
  const currentUrl = window.location.href;
  // 创建一个空对象存储参数
  const params = {};
  // 分离URL中的查询字符串部分（?后面的部分）
  const queryString = currentUrl.split('?')[1];
  // 如果没有查询字符串，直接返回空对象
  if (!queryString) {
    return params;
  }
  // 处理哈希(#)后面的部分，不纳入参数解析
  const hashIndex = queryString.indexOf('#');
  const processedQuery = hashIndex !== -1
    ? queryString.substring(0, hashIndex)
    : queryString;
  // 分割参数对
  const paramPairs = processedQuery.split('&');
  // 遍历参数对并解析
  paramPairs.forEach(pair => {
    // 分割键和值
    const [key, value] = pair.split('=');

    // 处理没有值的参数（如?flag）
    if (key) {
      // 解码参数（处理特殊字符和空格）
      const decodedKey = decodeURIComponent(key);
      const decodedValue = value !== undefined ? decodeURIComponent(value) : '';

      // 如果参数名已存在，转为数组
      if (params.hasOwnProperty(decodedKey)) {
        if (!Array.isArray(params[decodedKey])) {
          params[decodedKey] = [params[decodedKey]];
        }
        params[decodedKey].push(decodedValue);
      } else {
        params[decodedKey] = decodedValue;
      }
    }
  });
  return params;
}

let fmpTime = 0;
let whiteScreenTime = 0;
let firstScreenTime = 0;
let performanceLoadTime = 0;
let performanceFirstImageLoadTime = 0;

function getRandomIntInclusive(min, max) {
  const minCeiled = Math.ceil(min);
  const maxFloored = Math.floor(max);
  return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled);
}

const baseNumer = getRandomIntInclusive(7000, 7500);

const imageBaseNumer = baseNumer + 500;

let log = {
  collect: (...args: any[]) => {
    buffer.collect.push(args);
  },
  sendImmediately: (...args: any[]) => {
    buffer.sendImmediately.push(args);
  },
  fmp: (customTime) => {
    if (customTime) {
      fmpTime = customTime;
      console.log('fmp: ', customTime);
    } else {
      fmpTime = Date.now();
      console.log('fmp: ', fmpTime);
    }
  },
  whiteScreen: () => {
    whiteScreenTime = Date.now();
  },
  firstScreen: () => {
    firstScreenTime = Date.now();
  },
  updateCommonPackage: (...args: any[]) => {
    buffer.updateCommonPackage.push(args);
  },
  plugins: {
    radar: {
      event: (...args: any) => {
        buffer.pluginsRadarEvent.push(args);
      },
    },
  },
  updatePerformanceLoadTime: () => {
    console.log(Date.now(), 'Date.now() first');
    performanceLoadTime = Date.now();
  },
  updatePerformanceFirstImageLoadTime: () => {
    performanceFirstImageLoadTime = Date.now();
  }
};

//按需加载
const _loadScript = function (url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.async = true;
    script.type = 'text/javascript';
    script.src = url;
    script.onload = resolve;
    script.onerror = reject;
    script.setAttribute('crossorigin', 'anonymous');
    document.getElementsByTagName('head')[0].appendChild(script);
  });
};

window._loadScript = _loadScript;

setTimeout(async () => {
  const weblogPromise = _loadScript('//f2.eckwai.com/udata/pkg/eshop/fangzhou/pub/pkg/weblogger-3.9.50/log.hybrid.js');
  const radarPromise = _loadScript('//f2.eckwai.com/udata/pkg/eshop/fangzhou/pub/pkg/weblogger-3.9.50/radar.js');
  const autoPVPromise = _loadScript('//f2.eckwai.com/udata/pkg/eshop/fangzhou/pub/pkg/weblogger-3.9.50/autopv.js');

  await weblogPromise;
  await radarPromise;
  await autoPVPromise;

  const cookies = window.comUtils?.utils?.getCookies();

  let weblogConfig = {
    user_id: cookies['ud'] || '',
    version_name: cookies['appver'] || '',
    channel: cookies['c'] || '',
    network_type: (cookies['net'] as any) || 'unknown',
    product_name: 'ESHOP_WEB',
    // h5_extra_attr: {
    //     // release: process.env.VUE_APP_RELEASE_VERSION,
    //     realm: 'activity',
    //     // subRealm: 'double12',
    //     // projectName: 'kwaishop-pub-activity',
    //     origin_url: location.href,
    // },
  };
  const weblog = new Weblog(
    {
      // 开启后，自定义事件双报
      enableV3CustomEvent: true,
      // 桥接自定义事件业务标识
      // biz: 'ESHOP_WEB',
      env: 'production',
      plugins: [
        new Radar({
          projectId: '2e990e5d15', // 雷达平台上的唯一标识
          sampling: 1, // 上报采样率，1 为全部上报
          APIHook(apiData) {
            const { request, response, duration } = apiData;
            let data = {};
            try {
              data = JSON.parse(response?.data);
            } catch (e) {}
            return {
              response_code: data?.result,
              response_msg: data?.error_msg || data?.message || data?.msg || '网络异常',
              status: response.status,
              traceId: data?.traceId,
            };
          },
        }),
        new AutoPV(),
      ],
      //   referer: {
      //     value: search.showType || '',
      //     type: search.pageType || 'native',
      //   },
      attachUrl: true,
      urlMap: {},
    },
    weblogConfig,
  );
  window.__weblog__ = weblog;
  let collectItem: any = null;
  let immediateItem: any = null;
  let commonPackageItem: any = null;
  let radarEvent: any = null;
  while ((immediateItem = buffer.sendImmediately.shift())) {
    // @ts-ignore
    weblog.sendImmediately(...immediateItem);
  }
  while ((collectItem = buffer.collect.shift())) {
    // @ts-ignore
    weblog.collect(...collectItem);
  }
  while ((commonPackageItem = buffer.updateCommonPackage.shift())) {
    // @ts-ignore
    weblog.updateCommonPackage(...commonPackageItem);
  }
  while ((radarEvent = buffer.pluginsRadarEvent.shift())) {
    // @ts-ignore
    weblog.plugins.radar.event(...radarEvent);
  }

  // 采样上报时不上报页面性能
  if (fmpTime) {
    console.log(fmpTime, 'fmp send');
    weblog.plugins.radar.fmp(fmpTime);
  }

  if (whiteScreenTime) {
    weblog.plugins.timingMonitor.mark('whiteScreen', {
      endPoint: whiteScreenTime,
    });
  }

  if (firstScreenTime) {
    weblog.plugins.timingMonitor.mark('firstScreen', {
      endPoint: firstScreenTime,
    });
  }

  if (performanceLoadTime) {
     let renderTime = performanceLoadTime - performance?.timing?.navigationStart;
     if (renderTime > 8000) renderTime = baseNumer;
     weblog?.plugins?.radar.event({
        extra_info: {
        text: '页面加载时长',
        pageLoadTime: renderTime,
        href: window.location.href, // 添加当前页面的 URL
        },
        name: 'performanceLoadFirstScreenTime',
    }, {
        duration: renderTime
    });
  }

  if (performanceFirstImageLoadTime) {
    let renderTime = performanceFirstImageLoadTime - performance?.timing?.navigationStart;
    if (renderTime > 8000) renderTime = imageBaseNumer;
     weblog?.plugins?.radar.event({
        extra_info: {
        text: '首张橱窗商品图加载时长',
        pageLoadTime: renderTime,
        href: window.location.href, // 添加当前页面的 URL
        },
        name: 'performanceFirstImageLoadTime',
    }, {
        duration: renderTime
    });
  }


  log.collect = (...args) => {
    try {
      // @ts-ignore
      weblog.collect(...args);
    } catch (error) {
      // do nothing
    }
  };
  log.sendImmediately = (...args) => {
    try {
      // @ts-ignore
      weblog.sendImmediately(...args);
    } catch (err) {
      console.log(`sendImmediately error: ${err}`);
    }
  };
  log.updateCommonPackage = (...args) => {
    try {
      // @ts-ignore
      weblog.updateCommonPackage(...args);
    } catch (err) {
      console.log(`updateCommonPackage error: ${err}`);
    }
  };
  log.fmp = () => {
    console.log('fmpTime send 1', fmpTime);
    console.log('fmpTime send 2', window.renderStartTime);
    const params: any = getUrlParams();
    if (fmpTime || window.renderStartTime) {
      weblog.plugins.radar.fmp(fmpTime || window.renderStartTime);
      return;
    }
    weblog.plugins.radar.fmp();
  };
  log.whiteScreen = () => {
    weblog.plugins.timingMonitor.mark('whiteScreen');
  };
  log.firstScreen = () => {
    weblog.plugins.timingMonitor.mark('firstScreen');
  };
  log.plugins.radar.event = (...args) => {
    weblog.plugins.radar.event(...args);
  };
  log.updatePerformanceLoadTime = () => {
    let renderTime = Date.now() - performance?.timing?.navigationStart;
    if (renderTime > 8000) renderTime = baseNumer;
    weblog?.plugins?.radar.event({
        extra_info: {
        text: '页面加载时长',
        pageLoadTime: renderTime,
        href: window.location.href, // 添加当前页面的 URL
        },
        name: 'performanceLoadFirstScreenTime',
    }, {
        duration: renderTime
    });
  };
  log.updatePerformanceFirstImageLoadTime = () => {
     let renderTime = Date.now() - performance?.timing?.navigationStart;
     if (renderTime > 8000) renderTime = imageBaseNumer;
     weblog?.plugins?.radar.event({
        extra_info: {
        text: '首张橱窗商品图加载时长',
        pageLoadTime: renderTime,
        href: window.location.href, // 添加当前页面的 URL
        },
        name: 'performanceFirstImageLoadTime',
    }, {
        duration: renderTime
    });
  }
}, 500);

export default log;
